import React from "react";

/**
 * Specialized Header for Session Expiration / Auth Modals
 * Matches the "Sign in-D" design with image background and circular X
 */
function CustomBrandedHeader({ onForceLogout }) {
  return (
    <div
      className="branded-header-container"
      style={{
        height: "158px",
        width: "100%",
        position: "relative",
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/tf_expectation_bg.svg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* 1. Close Button Container (Top Right) */}
      <div
        className="branded-header-close-wrap"
        onClick={onForceLogout}
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          width: "32px",
          height: "32px",
          backgroundColor: "#FFFFFF",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          zIndex: 10,
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/x_dark_blue.svg`}
          alt="Close"
          style={{ width: "14px", height: "14px" }}
        />
      </div>

      {/* 2. Logo Container (Center) */}
      <div className="branded-header-logo-wrap">
        <img
          src={`${process.env.PUBLIC_URL}/images/logo_white.svg`}
          alt="Plaintr Logotype"
          style={{ height: "45px", width: "auto" }}
        />
      </div>
    </div>
  );
}

export default CustomBrandedHeader;
